document.addEventListener('DOMContentLoaded', function () {
  const buttons = document.querySelectorAll('.collection-view .change-view');
  const productGrid = document.querySelector('.custom_collection_grid');

  if (!buttons.length || !productGrid) return;

  // 👉 Default view (grid)
  let currentView = 'grid';

  // 👉 Apply default view on load
  productGrid.classList.add(currentView + '-view');

  buttons.forEach(btn => {
    if (btn.dataset.view === currentView) {
      btn.classList.add('active');
    } else {
      btn.classList.remove('active');
    }
  });

  function restartAnimation() {
    const items = productGrid.querySelectorAll('.grid__item');

    items.forEach(item => {
      item.classList.remove('animate--slide-in');
      void item.offsetWidth; // force reflow
      item.classList.add('animate--slide-in');
    });
  }

  buttons.forEach(btn => {
    btn.addEventListener('click', function (e) {
      e.preventDefault();

      const selectedView = this.dataset.view;

      // 👉 Active button toggle
      buttons.forEach(b => b.classList.remove('active'));
      this.classList.add('active');

      // 👉 View class toggle
      productGrid.classList.remove('grid-view', 'list-view');
      productGrid.classList.add(selectedView + '-view');

      // 👉 Restart animation
      restartAnimation();
    });
  });
});

// NL custom code megamenu open close
document.addEventListener('DOMContentLoaded', function () {

  // Handle ALL details inside menu drawer
  document.querySelectorAll('.menu-drawer details').forEach(function(detail) {

    detail.addEventListener('toggle', function () {

      // Only run when opening
      if (!this.open) return;

      // Find closest UL
      var parentUl = this.closest('ul');
      if (!parentUl) return;

      // Get only direct sibling details at SAME LEVEL
      var siblingDetails = parentUl.querySelectorAll(':scope > li > details[open]');

      siblingDetails.forEach(function(other) {
        if (other !== detail) {
          other.removeAttribute('open');
        }
      });
    });
  });
});

// NL custom code megamenu open close

